import { ReactComponent as V1 } from "../../assets/icons/battery/circular/Vector.svg";
import { ReactComponent as V2 } from "../../assets/icons/battery/circular/Vector-1.svg";
import { ReactComponent as V3 } from "../../assets/icons/battery/circular/Vector-2.svg";
import { ReactComponent as V4 } from "../../assets/icons/battery/circular/Vector-3.svg";
import { ReactComponent as V5 } from "../../assets/icons/battery/circular/Vector-4.svg";
import { ReactComponent as V6 } from "../../assets/icons/battery/circular/Vector-5.svg";
import { ReactComponent as V7 } from "../../assets/icons/battery/circular/Vector-6.svg";
import { ReactComponent as V8 } from "../../assets/icons/battery/circular/Vector-7.svg";


const CircularBattery = ({percent})=>{
    return (
        <div style={{
                position:'absolute',
                width:'90px',
                height:'90px',
                display:'flex',
                justifyContent:'center'
            }}
        >
        
        <div style={{
               position: "absolute",
               left:'-0.01%',
               right:'78.81%',
               top:'16.52%',
               bottom:'51.37%',
               color:percent > 1 ?'#070A0E' :'#EBEEF7'
           }} 
        >
            <V1/>
        </div>
        
        <div style={{
               position: "absolute",
               left:'0.01%',
               right:'78.8%',
               top:'51.37%',
               bottom:'15.53%',
               color:percent > 13 ?'#070A0E' :'#EBEEF7'
           }}
        >
            <V2/>
        </div>
        
        <div  style={{
               position: "absolute",
               left:'16.53%',
               right:'51.37%',
               top:'78.82%',
               bottom:'0%',
               color:percent > 26 ?'#070A0E' :'#EBEEF7'
           }}
        >
            <V3/>
        </div>
        
        <div style={{
               position: "absolute",
               left:'51.37%',
               right:'16.53%',
               top:'78.81%',
               bottom:'0%',
               color:percent > 40 ?'#070A0E' :'#EBEEF7'
           }}
        >
            <V4/>
        </div>
        
        <div style={{
               position: "absolute",
               left:'78.8%',
               right:'0.01%',
               top:'51.37%',
               bottom:'16.52%',
               color:percent > 50 ?'#070A0E' :'#EBEEF7'
           }}>
            <V5/>
        </div>
        
        <div style={{
               position: "absolute",
               left:'78.8%',
               right:'0%',
               top:'16.51%',
               bottom:'51.37%',
               color:percent > 65 ?'#070A0E' :'#EBEEF7'
           }}
        >
            <V6/>
        </div>
        
        
        <div style={{
               position: "absolute",
               left:'51.37%',
               right:'16.52%',
               top:'0%',
               bottom: "78.82%",
               color:percent > 80 ?'#070A0E' :'#EBEEF7'
           }}
        >
            <V7/>
        </div>
        
        <div style={{
               position: "absolute",
               left:'16.52%',
               right:'51.37%',
               top:'0%',
               bottom:'78.83%',
               color:percent > 90 ?'#070A0E' :'#EBEEF7'
           }}
        >
            <V8/>
        </div>
   
        <span style={{
                position: "absolute",
                top:'40%',
                fontFamily:"Roboto",
                fontSize:'16px',
                fontWeight:'500',
                color: '#070A0E'
            }}
        > 
            {percent.toString()}%
        </span>
    </div>
    );
}

export default CircularBattery;